import { render, staticRenderFns } from "./AnnexDocuments.vue?vue&type=template&id=b0ee6008"
import script from "./AnnexDocuments.vue?vue&type=script&lang=js"
export * from "./AnnexDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports